export default __webpack_public_path__ + "static/media/AngsanaNew.5b17e926.ttf";